import React from 'react'

import { debounce } from '@/utils'
import { SearchField } from '../SearchField'
import { useTranslation } from 'react-i18next'

type TableSearchProps = {
  defaultValue?: string
  placeholder?: string
  handleSearch: (text: string) => void
  style?: React.CSSProperties
}

export function TableSearch({ defaultValue, placeholder, handleSearch, style }: TableSearchProps) {
  const { t } = useTranslation()

  const placeholderText = defaultValue ?? placeholder ?? t('searchPlaceholder')

  return (
    <div className="TableSearch" style={style}>
      <SearchField
        onChange={debounce(handleSearch)}
        label="Search"
        defaultValue={defaultValue}
        placeholder={placeholderText}
      />
    </div>
  )
}
